export const GET_CURRENT_QUESTION_START = 'GET_CURRENT_QUESTION_START';
export const GET_CURRENT_QUESTION_SUCCESS = 'GET_CURRENT_QUESTION_SUCCESS';
export const GET_CURRENT_QUESTION_FAIL = 'GET_CURRENT_QUESTION_FAIL';
export const GET_CURRENT_QUESTION_RESET = 'GET_CURRENT_QUESTION_RESET';
